import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';

@Component({
    selector: 'app-idle-pop-up',
    templateUrl: './idle-pop-up.component.html',
    styleUrls: ['./idle-pop-up.component.scss'],
    standalone: false
})
export class IdlePopUpComponent {

  constructor(
    private localStorageService: LocalStorageService,
    private authService: AuthService
  ) { }


  logOut() {
    this.localStorageService.clearLocalStogareByKey('isUserLoggedOut');
    this.authService.signout();
  }
}
